// Small form primitives so screens don't repeat input markup.
import { DateControl } from './DateField';

export const Field = ({ label, children }) => (
  <div className="field">
    <label>{label}</label>
    {children}
  </div>
);

export const TextInput = ({ label, ...rest }) => (
  <Field label={label}>
    <input {...rest} />
  </Field>
);

export const NumberInput = ({ label, ...rest }) => (
  <Field label={label}>
    <input type="number" step="0.01" {...rest} />
  </Field>
);

// Typed dd/mm/yyyy or the calendar, either way an ISO value — see DateField. The
// label is passed down as well as rendered, so a Modal blocking Save on an unfinished
// date can name the field.
export const DateInput = ({ label, ...rest }) => (
  <Field label={label}>
    <DateControl label={label} {...rest} />
  </Field>
);

export const ColorInput = ({ label, ...rest }) => (
  <Field label={label}>
    <input type="color" className="color-input" {...rest} />
  </Field>
);

export const Textarea = ({ label, ...rest }) => (
  <Field label={label}>
    <textarea rows={3} {...rest} />
  </Field>
);

// options: [{ value, label }]
export const Select = ({ label, options, ...rest }) => (
  <Field label={label}>
    <select {...rest}>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </Field>
);

// Turn a label map ({ key: 'Hebrew' }) into <Select> options.
export const optionsFromMap = (map) => Object.entries(map).map(([value, label]) => ({ value, label }));
